
import React from 'react'
import { AppTableProvider } from './AppTableProvider'
import { AppTableProps } from './AppTableServer'
import { AppTableColumn } from './AppTableColumn'
import { AppFilter } from 'qcc'

export class AppTable extends React.Component<AppTableProps> {

  static Col = AppTableColumn
  static ColDate = AppTableColumn.Date
  static ColDateTime = AppTableColumn.DateTime
  static ColIndex = AppTableColumn.Index
  static ColInt = AppTableColumn.Int
  static ColMoney = AppTableColumn.Money
  static ColCheckbox = AppTableColumn.Checkbox
  static ColAction = AppTableColumn.Action

  componentDidMount() {
    this.props.exportRef && this.props.exportRef(this);
  }

  fetch = async () => {
    this.refAppTableProvider.current && await this.refAppTableProvider.current.fetchData();
  }

  onQuery = async (filterList?: AppFilter[], data?: any) => {
    this.refAppTableProvider.current && this.refAppTableProvider.current.onQuery(filterList, data);
  }

  setDataSource = (dataSource: any[]) => {
    this.refAppTableProvider.current && this.refAppTableProvider.current.updateDataSource(dataSource);
  }

  getSelected = () => {
    return this.refAppTableProvider.current.getSelected();
  }

  getDataList = () => {
    return this.refAppTableProvider.current && this.refAppTableProvider.current.state.dataList;
  }

  getAppTableQuery = () => {
    return this.refAppTableProvider.current && this.refAppTableProvider.current.getAppTableQuery();
  }

  refAppTableProvider = React.createRef<AppTableProvider>();

  render() {
    return <AppTableProvider ref={this.refAppTableProvider} {...this.props} children={this.props.children} />
  }
}




// WEBPACK FOOTER //
// ./src/qcc/AppTable/AppTable.tsx